<template>
  <!-- 案件詳細 -->
  <div id="KenshinRequestContentChange">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinRequestContentChange"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 受付内容変更</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select id="type" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>機種</th>
            <td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
            <th>依頼元種別</th>
            <td><select id="clientType" v-model="searchConditions.clientType"><option></option><option :value="role.role_corporation">企業</option><option :value="role.role_dealer">ディーラー</option><option :value="role.role_hospital">医療機関</option><option :value="role.role_accommodations">宿泊施設</option></select></td>
          </tr>
          <tr>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>企業名</th>
            <td><input type="text" id="corporation" v-model="searchConditions.companyName"/></td>
            <th>ステータス</th>
            <td><select v-model="searchConditions.status"><option v-for="status in statusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
            <th>シリアル</th>
            <td><input type="text" id="serialInput" v-model="searchConditions.serial" @keyup.enter="onKeyupEnter()"/></td>
          </tr>
          <tr>
            <th>出荷予定日</th>
            <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult">
        <b-table
            id="kenshinRequestContentChangeTable"
            :data="data"
            :paginated="true"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">       
              <b-table-column field="receiptNumber" label="受付番号" width="180" sortable centered>
                <router-link :to="{name:'KenshinDetailEdit', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions}}" style="align-items: flex-end;">{{props.row.receiptNumber}}<b-icon icon="lead-pencil" class="requestEdiitIcon"/></router-link>
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷予定日" width="100" sortable>
                {{props.row.shippingDate}}
              </b-table-column>
              <b-table-column field="model" label="機種" width="200" sortable >
                {{getChoiceName(props.row.model,kenshinDeviceList)}}<span v-if="props.row.demo" class="demo" />
              </b-table-column>
              <b-table-column field="units" label="台数" width="50" sortable centered>
                {{props.row.units}}
              </b-table-column>
              <b-table-column field="companyName" label="企業名" width="350" sortable >
                {{props.row.companyName}}　{{props.row.officeName}}
              </b-table-column>
              <b-table-column field="address" label="配送先" width="400" sortable >
                {{props.row.address}}
              </b-table-column>
              <b-table-column field="status" label="ステータス" width="10" sortable centered>
                <span :class="getKenshinTagClass(props.row.status)">
                  {{getStatusName(props.row.status)}}
                </span>
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinRequestContentChange",
  methods: {
    onKeyupEnter: function(){
      //シリアルを取得
      let serialItems = this.searchConditions.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.searchConditions.serial = serialItems[1]
      }
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getKenshinReceptionContentsListPOST;
      var successCallBack = this.getKenshinReceptionContentsListPOSTSuccess;
      var errorCallBack = this.getKenshinReceptionContentsListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinReceptionContentsListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.status = obj.status && obj.status.length!=0 ? JSON.parse(obj.status) : []
      if(!obj.clientType){
        delete obj.clientType
      }
      return client.apis.internalKenshin.getKenshinReceptionContentsListPOST({
        body:obj
      });
    },
    getKenshinReceptionContentsListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinReceptionContentsListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    var statusList = [
      {name:"未出荷", code:"[1,2,3,11]"},
      {name:"出荷済み", code:"[4,5,6,7,8,9,10,12,13,14]"}
    ]
    statusList.unshift({})
    
    return {
      takeOverSearchParams,
      data : [],
      hasResult:false,
      role: role,
      kenshinDeviceList,
      statusList,
      searchConditions:{
        receiptNumber:"",
        demo:"",
        inspectionKind:"",
        model:"",
        clientType:"",
        client:"",
        companyName:"",
        status:"",
        serial:"",
        shippingDateStart:"",
        shippingDateEnd:""
      }
    };
  },
  async mounted() {
    // 選択肢マスタ取得
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    kenshinNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinRequestContentChange.vue